import {Locale} from '@aboutyou/config';
import {useIsRTL} from '@aboutyou/i18n';
import {Fade} from '@aboutyou/transitions';
import {styled} from '@linaria/react';
import React from 'react';
import {
  mediaDesktopAndUp,
  mediaMobileOnly,
} from '../../../../constants/customMedia';
import {VipLogo} from './VipLogo';
import {WoohooCampaignLogo} from './WoohooCampaignLogo';

export interface SpecialLogoOptions {
  className?: string;
  style?: React.CSSProperties;
  isVip: boolean;
  vipLandingPageUrl: string;
  woohooCampaign?: {isCampaignLive: boolean; locale: Locale};
  BASCampaignHeaderLogoComponent: React.ReactNode | null;
}

export const SpecialLogo: React.FC<SpecialLogoOptions> = ({
  className,
  style,
  isVip,
  vipLandingPageUrl,
  woohooCampaign,
  BASCampaignHeaderLogoComponent,
}) => {
  const isRTL = useIsRTL();

  if (!woohooCampaign && !BASCampaignHeaderLogoComponent && !isVip) {
    return null;
  }

  return (
    <Wrapper
      className={className}
      style={style}
      $isRTL={isRTL}
      $isBASComponent={Boolean(BASCampaignHeaderLogoComponent)}
    >
      {woohooCampaign && <WoohooCampaignLogo locale={woohooCampaign?.locale} />}

      <Fade mounted={isVip} duration={500} delay={{mount: 1300, unmount: 0}}>
        <VipWrapper>
          <VipLogo dataTestId="vipLogo" vipLandingPageUrl={vipLandingPageUrl} />
        </VipWrapper>
      </Fade>

      {BASCampaignHeaderLogoComponent ?? null}
    </Wrapper>
  );
};

const VipWrapper = styled.span`
  opacity: 0;
  padding: 0 4px;
  height: 30px;
`;

export const Wrapper = styled.div<{$isRTL: boolean; $isBASComponent: boolean}>`
  display: flex;
  align-items: center;
  width: max-content;
  height: 100%;

  @media ${mediaMobileOnly} {
    flex-basis: ${({$isBASComponent}) => ($isBASComponent ? '50%' : 'auto')};
  }

  @media ${mediaDesktopAndUp} {
    [dir='rtl'] & {
      margin-right: unset;
    }

    [dir='ltr'] & {
      margin-left: unset;
    }
  }
`;
